import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { CatalogosProvider } from './context/CatalogosContext';
import { Toaster } from 'sonner';
import DynamicHead from './components/DynamicHead';
import Login from './pages/Login';
import DashboardLayout from './layouts/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Solicitudes from './pages/Solicitudes';
import Usuarios from './pages/Usuarios';
import Roles from './pages/Roles';
import Menus from './pages/Menus';
import Configuracion from './pages/Configuracion';
import ConfiguracionGeneral from './pages/ConfiguracionGeneral';
import Proyectos from './pages/Proyectos';
import Proveedores from './pages/Proveedores';
import Perfil from './pages/Perfil';
import Auditoria from './pages/Auditoria';
import Notificaciones from './pages/Notificaciones';
import EntregasUI from './pages/entregas/EntregasUI';
import EntregaDashboard from './pages/entregas/EntregaDashboard';
import EntregaConfiguracion from './pages/entregas/EntregaConfiguracion';
import EntregaNueva from './pages/entregas/EntregaNueva';
import EntregaDetalle from './pages/entregas/EntregaDetalle';
import EntregaInspeccion from './pages/entregas/EntregaInspeccion';
import EntregaProgramacion from './pages/entregas/EntregaProgramacion';
import CalendarioEntregas from './pages/entregas/CalendarioEntregas';
import AuditoriaEntregas from './pages/entregas/AuditoriaEntregas';
import SeleccionarCita from './pages/entregas/SeleccionarCita';
import AreasFuncionales from './pages/AreasFuncionales';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <CatalogosProvider>
          <DynamicHead />
          <BrowserRouter>
            <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<DashboardLayout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="solicitudes" element={<Solicitudes />} />
              <Route path="usuarios" element={<Usuarios />} />
              <Route path="roles" element={<Roles />} />
              <Route path="menus" element={<Menus />} />
              <Route path="configuracion" element={<Configuracion />} />
              <Route path="configuracion-general" element={<ConfiguracionGeneral />} />
              <Route path="proyectos" element={<Proyectos />} />
              <Route path="proveedores" element={<Proveedores />} />
              <Route path="perfil" element={<Perfil />} />
            <Route path="auditoria" element={<Auditoria />} />
            <Route path="notificaciones" element={<Notificaciones />} />
            <Route path="areas-funcionales" element={<AreasFuncionales />} />
            <Route path="entregas" element={<EntregasUI />} />
            <Route path="entregas/nueva" element={<EntregaNueva />} />
            <Route path="entregas/dashboard" element={<EntregaDashboard />} />
            <Route path="entregas/configuracion" element={<EntregaConfiguracion />} />
            <Route path="entregas/calendario" element={<CalendarioEntregas />} />
            <Route path="entregas/auditoria" element={<AuditoriaEntregas />} />
            <Route path="entregas/:id" element={<EntregaDetalle />} />
            <Route path="entregas/:id/inspeccion" element={<EntregaInspeccion />} />
            <Route path="entregas/:id/programacion" element={<EntregaProgramacion />} />
          </Route>
          <Route path="/seleccionar-cita/:token" element={<SeleccionarCita />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
        </CatalogosProvider>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
